import { mainSiteUrl } from '@/mocks/categories';

const features = [
  { icon: 'ri-database-2-line', title: 'Organized Lists' },
  { icon: 'ri-scales-3-line', title: 'Agent Compare' },
  { icon: 'ri-shield-check-line', title: 'Safe Shopping' },
  { icon: 'ri-guide-line', title: 'Buying Guides' },
  { icon: 'ri-refresh-line', title: 'Updated Daily' },
];

export default function AboutSection() {
  return (
    <section id="about" className="relative bg-background-950 py-16 md:py-24">
      <div className="w-full px-4 md:px-10 max-w-[1024px] mx-auto text-center">
        <span className="text-white/40 text-xs font-medium tracking-[0.15em] uppercase">
          Why Hipobuy Spreadsheet
        </span>
        <h2 className="mt-4 text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white/90 leading-tight max-w-3xl mx-auto">
          Your Trusted Resource for Smarter Product Research
        </h2>
        <p className="mt-6 text-white/50 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
          Hipobuy Spreadsheet is an organized product research system that helps shoppers discover products,
          compare information and save time when browsing large marketplaces.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap px-7 py-3 rounded-full bg-white text-foreground-900 font-semibold text-sm hover:bg-white/90 transition-all duration-200 cursor-pointer"
          >
            Explore Hipobuy Spreadsheet
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap px-7 py-3 rounded-full border border-white/30 text-white font-semibold text-sm hover:bg-white/8 transition-all duration-200 cursor-pointer"
          >
            View Complete Guides
          </a>
        </div>

        <div className="mt-16 grid grid-cols-2 sm:grid-cols-5 gap-4">
          {features.map((f) => (
            <div
              key={f.title}
              className="flex flex-col items-center gap-3 p-5 rounded-2xl bg-white/[0.04] hover:bg-white/[0.08] transition-colors duration-200"
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${f.icon} text-white/60 text-xl`}></i>
              </div>
              <span className="text-white/70 text-xs font-medium">{f.title}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}